import { HttpClient, RouteGenerator } from "silver";
import { MyonApiResponse, isMyonApiSuccess } from "shared/Api/MyonApiResponse";
import { GradeLevel } from "shared/Api/GradeLevel";

type ArticleFlag = "sensitive"|"legislation";

type Article = {
	id: number;
	title: string;
	ordinal: number;
	published: number;
	publishedString: string;
	edition: number;
	editionUrl: string;
	category: string;
	categoryUrl: string;
	imageUrl: string;
	imageCaption: string;
	textPreview: string;
	url: string;
	flags: ArticleFlag[];
};

export type ArticleSearchParams = Partial<{
	buildingId: number;
	offset: number;
	count: number;

	category : string;
	text: string;
	effectiveGrade: GradeLevel | [ GradeLevel, GradeLevel ];
	publishedSince: number;
	flagSensitive: boolean;
	flagLegislation: boolean;
}>

export type ArticleSearchResult = {
	article: Article,
	minUserGradeLevelId: GradeLevel,
	gradeLevelOverride?: {
		value: GradeLevel,
		setBy: string;
		timestamp: number;
	}
};

export type ArticleSearchResponse = {
	total: number,
	results: ArticleSearchResult[];
};

export class ArticleSearchService {
	constructor(
		private httpClient: HttpClient,
		private router: RouteGenerator
	) { }

	async search(params: ArticleSearchParams = { }): Promise<ArticleSearchResponse> {
		const url = this.router.generate("api/news/article", "search", {}, "json");
		const response: MyonApiResponse<ArticleSearchResponse> = await this.httpClient.post(url, { body: params });
		if (!isMyonApiSuccess(response)) {
			throw new Error("Myon api request failed");
		}
		return response.result;
	}

}
